<template>
  <div class="sports_item_detailx">
    <Empty description="加载中..." v-if="itemDetail == ''" />
    <div class="body" v-else>
      <mVideo
        :videoUrl="itemDetail.mediaurl"
        v-if="itemDetail.mediaurl"
        height="4.72rem"
        fit="contain"
      ></mVideo>
      <VanImage :src="itemDetail.icon" style="width: 7.5rem;height:4.72rem;" v-else></VanImage>
<!--      <Panel class="header" :title="itemDetail.title">-->
<!--        <CellGroup :border="false">-->
<!--          <Cell title="开始时间" icon="clock-o">-->
<!--            {{-->
<!--            itemDetail.start_time-->
<!--            }}-->
<!--          </Cell>-->
<!--          <Cell title="截止时间" icon="clock-o">{{ itemDetail.end_time }}</Cell>-->
<!--          <Cell-->
<!--            title="投票开始时间"-->
<!--            v-if="itemDetail.type == 4 && itemDetail.vote_start_time"-->
<!--            icon="clock-o"-->
<!--          >{{ itemDetail.vote_start_time }}</Cell>-->
<!--          <Cell-->
<!--            title="投票截止时间"-->
<!--            v-if="itemDetail.type == 4 && itemDetail.vote_end_time"-->
<!--            icon="clock-o"-->
<!--          >{{ itemDetail.vote_end_time }}</Cell>-->
<!--          <Cell title="联系方式" icon="contact" v-if="itemDetail.contact && itemDetail.contact!=0">-->
<!--            {{-->
<!--            itemDetail.contact-->
<!--            }}-->
<!--          </Cell>-->
<!--          <Cell-->
<!--            title="活动规程"-->
<!--            icon="todo-list-o"-->
<!--            is-link-->
<!--            v-if="itemDetail.rules"-->
<!--            @click="show = true"-->
<!--          ></Cell>-->
<!--        </CellGroup>-->
<!--      </Panel>-->

<!--      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">-->
<!--        <div class="vhtml" v-html="itemDetail.rules"></div>-->
<!--      </Popup>-->

      <Panel class="header" :title="itemDetail.title">
        <div
          v-html="itemDetail.content"
          class="vhtml"
          style="font-size: 14px;padding:.2rem .3rem .2rem;"
        ></div>
      </Panel>
      <div class="x_rank">
        <div class="x_l">
          <div class="joinuser">
            <van-image
                :src="item.avatarurl"
                v-for="(item, index) in joinList.slice(0, 4)"
                :key="index"
                :style="
                  `transform:translateX(${(joinList.slice(0, 4).length -
                    1 -
                    index) *
                    25}%)`
                "
                :data-index="index"
            />

          </div>
          <div class="pp">{{ itemDetail.total }}人已发起挑战</div>
        </div>
        <div class="x_r">
          <img src="https://oss.mcloud.moveclub.cn/mpms/20210715/1626340017-60effab17d0e9.png" alt="">
          <div class="gox">
            <div>{{ itemDetail.title }}榜单</div>
            <div class="btn" @click="goRank">查看榜单</div>
          </div>
        </div>
      </div>
    </div>
    <Footbar>
      <Cell slot="footbar" v-if="itemDetail && itemDetail.register_type == 1">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          type="warning"
          block
          :disabled="itemDetail.disabled"
          :to="{ name: 'joinSports', params: this.$route.params }"
        >{{ itemDetail.tips }}</Button>
        <Button
          v-else
          round
          type="warning"
          block
          :to="{ name: 'sportsQues', params: {acid: 972} }"
        >奥运小知识</Button>
      </Cell>

      <Cell slot="footbar" v-else>
        <Button
          v-if="itemDetail.register_type == 2"
          round
          type="warning"
          block
          :color="buttonColor"
          :url="itemDetail.register_type_value"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 3"
          round
          type="warning"
          block
          :color="buttonColor"
          @click="openImg(itemDetail.register_type_value)"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 4"
          round
          type="warning"
          block
          :color="buttonColor"
          @click="jumpMp(itemDetail.register_type_value)"
        >立即参与</Button>
      </Cell>
    </Footbar>
    <van-dialog v-if="itemDetail.register_type == 3" v-model="show" title="长按跳转">
      <div class="img-area">
        <img :src="itemDetail.register_type_value" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import rankList from "./rank";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup } from "vant";
import "./index.less";
import imgurl from "@/assets/img/common/default.png";
import { Base64 } from "js-base64";
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["getOnlyUserInfo"]),
    imgurl() {
      return imgurl;
    },
    buttonColor() {
      // let detail = this.detail;
      // if (!detail) return "#ccc";
      // return `${detail.tabstyle[0]["color"]}`;
      return '#6F2609'
    },
  },
  components: {
    mVideo,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    Footbar,
    VanImage: Image,
    rankList,
    Popup,
  },
  props: ["item_sub_id", "sports_id"],
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
    };
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
    goRank() {
      // :to=""
      if (+this.itemDetail.type === 5) {
        wx.miniProgram.navigateTo({
          url: `/pages/rank/steps/index?activity_id=${this.item_sub_id}`,
        });
      } else {
        this.$router.push({ name: "sportsRankX", params: this.$route.params });
      }
    },
    jumpMp(value) {
      let jump = {
        appId: value
      }
      value = Base64.encodeURI(JSON.stringify(jump));
      //跳转小程序 webview无法直接跳转外部小程序 需要通过当前小程序中转
      wx.miniProgram.navigateTo({
        url: `/pages/jumpmp/index?jumpinfo=${value}`,
      });
    },
    openImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      Promise.all([
        this.$api.sports.sportsMain(this.sports_id),
        this.$api.sports.getComparegame(params),
      ]).then(
        (res) => {
          let { bgstyle, id, tabstyle, introstyle, title } = res[0].data;
          try {
            bgstyle = JSON.parse(bgstyle);
            tabstyle = JSON.parse(tabstyle);
            introstyle = JSON.parse(introstyle);
          } catch (e) {
            console.error(e);
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title };
          this.joinList = Object.assign([], res[1]["data"]["list"]);
          delete res[1]["data"]["list"];
          let { start_time, end_time, sex_limit, age_limit } = res[1]["data"];
          start_time = moment(start_time).valueOf();
          end_time = moment(end_time).valueOf();
          var sys_time = res[1]["sys_time"] * 1000;
          let tips,
            disabled = true;
          if (sys_time < start_time) {
            tips = "活动未开始";
          } else if (sys_time > end_time) {
            tips = "活动已结束";
          } else {
            tips = "上传视频";
            disabled = false;
          }
          this.itemDetail = Object.assign(res[1]["data"], { tips, disabled });
          this.$toast.clear();
          //判断 是否需要 限制性别 或生日 如果需要则要填写信息
          if (+sex_limit !== 0 || +age_limit !== 0) {
            let { name, phone, id_number } = this.getOnlyUserInfo;

            console.log(name);
            console.log(phone);
            console.log(id_number);

            if (!!name && !!phone && !!id_number) {
            } else {
              //需要补全信息
              this.toggleShowFill(true);
              return;
            }
          }
        },
        () => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.init();
    this.cf.wxShareConf();
  },
};
</script>

<style scoped>
.html >>> img {
  max-width: 100%;
}

.img-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-area img {
  max-width: 100%;
}
</style>
